import React from 'react';

function PercentItem({title, percent}) {
    return <>
        <div className="d-flex justify-content-between">
            <span>{title}</span>
            <span>{percent}%</span>
        </div>
        <div className={"progress-bar bg-info mt-1"} style={{height: 3, width: percent + "%"}}/>
    </>
}

export default PercentItem
